import { useState } from "react";

export const useInput = (initialValue: any) => {
  const [value, setValue] = useState(initialValue);
  const onChange = (e: { target: { value: any; }; }) => {
    // e.stopPropagation();
    setValue(() => {
      const newState = {...e.target.value}
      return newState;
    });
  };
  return { value, setValue, onChange };
};
